module.exports = __webpack_public_path__ + "img/comic-couple.6d821807.jpg";